import React, { useEffect, useState } from 'react';
import QualityControlService from './../../services/QualityControlService/QualityControlService';
import GearSpinner from '../../components/GearSpinner/GearSpinner';
import './StatusModal.css';

const StatusModal = ({ isShow, onClose }) => {
	const [statusData, setStatusData] = useState([]);
	const [isShowLoader, setIsShowLoader] = useState(false);
	const qualityControlService = new QualityControlService();

	useEffect(() => {
		if (isShow) {
			setIsShowLoader(true); // Reset loader when modal opens
			qualityControlService.getStatus()
				.then((response) => {
					if (response.status === 200 && response.data.status === 'success') {
						setStatusData(response.data.result);
					} else {
						setStatusData([]);
					}
				})
				.catch((error) => {
					console.error("Error fetching status:", error);
					setStatusData([]);
				})
				.finally(() => {
					setIsShowLoader(false);
				});
		}
	}, [isShow]);

	return (
		<React.Fragment>
			<div className={`modal fade modal-overlay ${isShow ? 'show' : ''}`} id="statusModal" tabIndex="-1" aria-labelledby="statusModalLabel" aria-hidden="true" style={{ display: `${isShow ? 'block' : 'none'}` }}>
				<div className="modal-dialog modal-dialog-centered modal-lg">
					<div className="modal-content">
						<div className="modal-header">
							<button type="button" className="btn-close" onClick={onClose}></button>
						</div>
						<div className="modal-body">
							<table className="table table-bordered">
								<thead>
									<tr>
										<th className="text-center">Status</th>
										<th className="text-center">Description</th>
									</tr>
								</thead>
								<tbody>
									{isShowLoader ? (
										<tr>
											<td colSpan="2" className="text-center"><GearSpinner /></td>
										</tr>
									) : statusData.length > 0 ? (
										statusData.map((item, index) => (
											<tr key={index}>
												<td className="text-center"><strong>{item.status}</strong></td>
												<td>{item.description}</td>
											</tr>
										))
									) : (
										<tr>
											<td colSpan="2" className="text-center">No data available</td>
										</tr>
									)}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default StatusModal;